var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.pageHeaderActionsConfig,
          "left-side-class": "col-xl-5",
          page: {
            icon: "fas fa-user-circle",
            title: "Manejo de Reembolso y Pago Directo",
            routes: [
              "Inicio",
              "Estudiante",
              "Manejo de Reembolso y Pago Directo"
            ]
          },
          "right-side-class":
            "col-xl-7 align-items-end d-flex pb-3 justify-content-end"
        }
      }),
      _vm.toggleStatusCard
        ? _c("card-status-transition", {
            attrs: {
              role: _vm.currentUserRole,
              statuses: _vm.filteredAvailableStatuses,
              title: "Cambiar estatus de la factura"
            },
            on: {
              "on-close": function($event) {
                _vm.toggleStatusCard = false
              },
              "on-continue": _vm.onSwitchStatus
            }
          })
        : _vm._e(),
      _vm.showStatusCardReadonly
        ? _c("card-status-readonly", {
            attrs: {
              comment: this.infoData.statusComment,
              title: this.infoData.statusName
            }
          })
        : _vm._e(),
      _vm.toggleAdjustmentCard
        ? _c("create-adjustment", {
            on: {
              "on-close": function($event) {
                _vm.toggleAdjustmentCard = false
              },
              "on-save": function($event) {
                return _vm.onSaveAdjustmentHandler($event)
              }
            }
          })
        : _vm._e(),
      _c("board", {
        staticClass: "mb-4",
        attrs: { details: _vm.detailsBoard }
      }),
      _c(
        "custom-tab",
        {
          key: "f",
          staticClass: "custom-nav-container custom-nav-colors font-18",
          attrs: {
            "content-class": "mt-3 pb-5 font-18",
            "nav-class": "font-18",
            "no-nav-style": true
          }
        },
        [
          _c(
            "custom-tab-item",
            {
              staticClass: "mt-3",
              attrs: {
                active: _vm.currentIndexTab == _vm.detailsInfoTabs.Resumen,
                lazy: "",
                title: "Resumen"
              },
              on: {
                click: function($event) {
                  return _vm.onActiveTab(_vm.detailsInfoTabs.Resumen)
                }
              }
            },
            [
              _vm.infoData
                ? _c("reinbursement-resume", {
                    key: _vm.resumeKey,
                    ref: "reinbursementResumeRef",
                    attrs: {
                      id: "reinbursement-resume-provider",
                      data: _vm.infoData,
                      "is-read-only": _vm.isReadOnly,
                      "proposal-documents": _vm.infoData.proposalDocuments
                    },
                    on: {
                      "on-amount-change": _vm.updateAmount,
                      "on-check-period": _vm.updatePeriods,
                      "on-comment-change": _vm.updateComment,
                      "refresh-data": _vm.onRefreshData
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          !_vm.isNewStatus
            ? _c(
                "custom-tab-item",
                {
                  staticClass: "mt-3",
                  attrs: {
                    active:
                      _vm.currentIndexTab == _vm.detailsInfoTabs.Historial,
                    lazy: "",
                    title: "Historial"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onActiveTab(_vm.detailsInfoTabs.Historial)
                    }
                  }
                },
                [
                  _c("tracking-history", {
                    attrs: { "request-id": _vm.requestId }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.canShowAdjustments
            ? _c(
                "custom-tab-item",
                {
                  staticClass: "mt-3",
                  attrs: {
                    active: _vm.currentIndexTab == _vm.detailsInfoTabs.Ajustes,
                    lazy: "",
                    title: "Ajustes"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onActiveTab(_vm.detailsInfoTabs.Ajustes)
                    }
                  }
                },
                [
                  _c("adjustment-history", {
                    ref: "adjustmentHistoryRef",
                    attrs: { data: _vm.infoData },
                    on: {
                      "on-delete-adjustment": function($event) {
                        return _vm.onDeleteAdjustmentHandler($event)
                      },
                      "on-edit-adjustment": function($event) {
                        return _vm.onEditAdjustmentHandler($event)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.canShowPayments
            ? _c(
                "custom-tab-item",
                {
                  staticClass: "mt-3",
                  attrs: {
                    active: _vm.currentIndexTab == _vm.detailsInfoTabs.Pagos,
                    lazy: "",
                    title: "Pagos"
                  },
                  on: { click: () => _vm.showPaymentTab() }
                },
                [
                  _c("payment-view", {
                    ref: "paymentViewRef",
                    attrs: {
                      "academic-year-id": _vm.infoData.academicYearId,
                      "can-manually-set-voucher-id":
                        _vm.canManuallySetVoucherId,
                      "determination-id": _vm.infoData.determinationId,
                      "disbursement-amount": _vm.infoData.amountToRefund,
                      "disbursement-info": _vm.paymentInfo,
                      "disbursement-status": _vm.infoData.statusId,
                      documents: _vm.infoData.documents,
                      "payment-model": _vm.infoData.paymentId,
                      "request-id": _vm.infoData.requestId,
                      "tap-request-id": _vm.infoData.tapRequestId,
                      year: _vm.infoData.year
                    },
                    on: {
                      "update:disbursementInfo": function($event) {
                        _vm.paymentInfo = $event
                      },
                      "update:disbursement-info": function($event) {
                        _vm.paymentInfo = $event
                      },
                      "delete-digit": function($event) {
                        return _vm.deleteBillingDigit($event)
                      },
                      "on-update-po": _vm.onUpdateVoucherStatusHandler,
                      saveDigit: function($event) {
                        return _vm.saveDisbursementDigits()
                      }
                    },
                    model: {
                      value: _vm.payment,
                      callback: function($$v) {
                        _vm.payment = $$v
                      },
                      expression: "payment"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.canShowFirmaTab
            ? _c(
                "custom-tab-item",
                {
                  staticClass: "mt-3",
                  attrs: {
                    active: _vm.currentIndexTab == _vm.detailsInfoTabs.Firma,
                    lazy: "",
                    title: "Firma"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onActiveTab(_vm.detailsInfoTabs.Firma)
                    }
                  }
                },
                [
                  _c("sign-plan", {
                    attrs: {
                      disabled: _vm.isSignPlanDisabled,
                      "is-electronic-signature": _vm.localIsElectronicSignature,
                      "question-label":
                        "¿Cuál será el mecanismo que se estará utilizando para firmar la Certificación de Reembolso?"
                    },
                    on: {
                      "update:isElectronicSignature": function($event) {
                        _vm.localIsElectronicSignature = $event
                      },
                      "update:is-electronic-signature": function($event) {
                        _vm.localIsElectronicSignature = $event
                      }
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "mt-4" },
                    [
                      _vm.hasSelectMechanisManuscript
                        ? _c("div", [
                            _c(
                              "div",
                              { staticClass: "font-weight-bold mb-2" },
                              [_vm._v("Documento")]
                            ),
                            _c("hr", { staticClass: "mt-0 mb-3" }),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row bg-secondary-3 rounded p-3 mb-3 ml-1 mr-0"
                              },
                              [
                                _c("div", { staticClass: "col-md-6" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-gray-6 font-14 font-weight-normal"
                                    },
                                    [_vm._v(" Tipo de Documento: ")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "color-black font-16 font-weight-normal"
                                    },
                                    [_vm._v(" Certificación de Reembolso ")]
                                  )
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-md-6 d-flex justify-content-end align-items-center flex-wrap"
                                  },
                                  [
                                    _vm.hasManuscriptDocUploaded &&
                                    !_vm.isReadyForNewManuscriptDoc
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center flex-wrap"
                                          },
                                          [
                                            !_vm.isReplacingManuscript
                                              ? [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "color-gray-6 font-14 mr-2"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.manuscriptCertificationDoc &&
                                                              _vm
                                                                .manuscriptCertificationDoc
                                                                .documentFilename
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  ),
                                                  _c("action-button", {
                                                    staticClass:
                                                      "px-1 mx-1 download-btn",
                                                    attrs: {
                                                      i:
                                                        "fas fa-file-download pl-2 m-0",
                                                      variant: "success"
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.downloadManuscriptCertification
                                                    }
                                                  }),
                                                  _vm.canReplaceManuscriptDoc
                                                    ? _c(
                                                        "action-button",
                                                        {
                                                          attrs: {
                                                            i:
                                                              "fas fa-undo-alt",
                                                            variant:
                                                              "outline-success ml-2"
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.startReplace
                                                          }
                                                        },
                                                        [_vm._v(" Reemplazar ")]
                                                      )
                                                    : _vm._e()
                                                ]
                                              : _c("custom-file-input", {
                                                  ref: "manuscriptCertRef",
                                                  attrs: {
                                                    accept: ".pdf",
                                                    "custom-error-msg":
                                                      "Favor de anejar un documento.",
                                                    "display-style": "normal",
                                                    "label-position": "left",
                                                    value:
                                                      _vm.manuscriptCertificationFile
                                                  },
                                                  on: {
                                                    input:
                                                      _vm.onManuscriptFileSelected
                                                  }
                                                })
                                          ],
                                          2
                                        )
                                      : _vm.hasDownloadedCertification
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "color-gray-6 font-14 font-weight-normal mr-3 mt-2"
                                              },
                                              [_vm._v(" Documento: ")]
                                            ),
                                            _c("custom-file-input", {
                                              ref: "manuscriptCertRef",
                                              attrs: {
                                                accept: ".pdf",
                                                "custom-error-msg":
                                                  "Favor de anejar un documento.",
                                                "display-style": "normal",
                                                "label-position": "left",
                                                value:
                                                  _vm.manuscriptCertificationFile
                                              },
                                              on: {
                                                input:
                                                  _vm.onManuscriptFileSelected
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _c("action-button", {
                                          attrs: {
                                            i: "fas fa-download",
                                            text: "Descargar Documento",
                                            variant: "success download-btn px-3"
                                          },
                                          on: {
                                            click:
                                              _vm.downloadAndMarkCertification
                                          }
                                        })
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        : _vm.hasSelectMechanismElectronica
                        ? _c("signature-hub-info", {
                            attrs: { "signature-info": _vm.signatureHubInfo },
                            on: {
                              "configure-sign": _vm.handleConfigureSignatures
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("sign-document-modal", {
        attrs: {
          error: _vm.signModal.error,
          loading: _vm.signModal.loading,
          open: _vm.signModal.open,
          url: _vm.signModal.url
        },
        on: { close: _vm.closeSignModal }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }